import { gql } from '@apollo/client';

const TransactionListingFields = gql`
  fragment TransactionListingFields on Transaction {
    cryptoAmount
    cryptoCurrency
    address
    txId
    txUrl
    createdAt
    blockchain
    blockNumber
  }
`;

const PageFields = gql`
  fragment PageFields on Page {
    __typename
    ... on CancelledPage {
      pageName
      cancelledPageData: pageData {
        __typename
        billType
        cancelUrl
        rating
        merchantName
        reason
      }
    }

    ... on BuyerDetailsUpdatePage {
      pageName
      pageData {
        fiatCurrency
        buyerDetailsUpdatePageFiatAmount: fiatAmount
        merchantName
        taxNumberRequired
        city
        billType
        expiresAt
        firstName
        lastName
        merchantName
        residentialAddress
        residentialCountry
      }
    }
    ... on CurrenciesPage {
      pageName
      pageData {
        merchantName
        fiatCurrency
        billType
        fiatTotal
        fiatCurrency
        fiatTotal
        eurAmount
        binancePayMethod
        travelRuleEnabled
        cryptoCurrencies {
          __typename
          amount
          currency
          rate
          blockchains {
            blockchain
            minExchangeRateTimer
            available
            reason
          }
        }
        methods {
          id
          name
        }
        expiresAt
      }
    }
    ... on EmailUpdatePage {
      pageData {
        expiresAt
        billType
        fiatAmount
        fiatCurrency
        merchantName
        reference
        __typename
        email
      }
      pageName
    }
    ... on CountryUpdatePage {
      pageData {
        expiresAt
        billType
        countries {
          alpha2code
          name
          __typename
        }
        CountryUpdatePageFiatAmount: fiatAmount
        fiatCurrency
        merchantName
        reference
        __typename
      }
      pageName
    }

    ... on ErrorPage {
      pageName
      pageData {
        info
        type
      }
    }
    ... on OverpaidPage {
      pageName
      pageData {
        billType
        merchantName
        refundable
        refundAmount
        paidAmount
        rating
        returnUrl
        expectedAmount
        cryptoCurrency
        confirmedTransactions {
          ...TransactionListingFields
        }
      }
    }
    ... on PaidPage {
      pageName
      paidPageData: pageData {
        billType
        merchantName
        returnUrl
        rating
        confirmedTransactions {
          ...TransactionListingFields
        }
      }
    }
    ... on PaymentDetectedPage {
      pageName
      pageData {
        merchantName
        __typename
        method {
          id
          name
        }
        blockchain
        cryptoCurrency
        method {
          id
          name
        }
        noOfConfirmationBlocks
        detectedTransactions {
          ...TransactionListingFields
        }
        billType
        expiresAt
      }
    }

    ... on UnderpaidPaymentDetectedPage {
      pageName
      UnderpaidPaymentDetectedPageData: pageData {
        billType
        merchantName
        __typename
        method {
          id
          name
        }
        blockchain
        cryptoCurrency
        method {
          id
          name
        }
        noOfConfirmationBlocks
        detectedTransactions {
          ...TransactionListingFields
        }

        confirmedTransactions {
          ...TransactionListingFields
        }
        expiresAt
      }
    }
    ... on PaymentDetectingPage {
      pageName
    }
    ... on PaymentExpiredPage {
      pageName
      pageData {
        merchantName
        paymentExpiredRefundable: refundable
        paymentExpiredBlockchain: blockchain
        paymentId
        rating
        billType
        paymentExpiredExpiresAt: expiresAt
        paymentExpiredConfirmedTransactions: confirmedTransactions {
          ...TransactionListingFields
        }
      }
    }
    ... on PaymentRejectedPage {
      pageName
      pageData {
        merchantName
        returnUrl
        billType
        paymentRejectedRefundable: refundable
        paymentRejectedBlockchain: blockchain
        paymentRejectedExpiresAt: expiresAt
        paymentRejectedConfirmedTransactions: confirmedTransactions {
          ...TransactionListingFields
        }
        paymentRejectedDetectedTransactions: detectedTransactions {
          ...TransactionListingFields
        }
      }
    }
    ... on PaymentPage {
      pageData {
        merchantName
        paymentId
        paymentStartedAt
        billType
        address
        blockchain
        paymentExpiresAt
        expiresAt
        cryptoAmount
        cryptoCurrency
        fiatCurrency
        fiatTotal
        exchangeRate
        remainingAmount
        paymentMethod
        providerMetadata {
          checkoutUrl
          deepLink
          qrCodeLink
          qrContent
          universalUrl
          __typename
        }
        solanaPaymentLink
        paymentPageMethod: method {
          id
          name
        }
        paymentPageAccumulatedAmount: accumulatedAmount
        paymentPageConfirmedTransactions: confirmedTransactions {
          ...TransactionListingFields
        }
        paymentPageDetectedTransactions: detectedTransactions {
          ...TransactionListingFields
        }
        paymentPageMethod: method {
          id
          name
        }
      }
      pageName
    }
    ... on KytVerificationStartedPage {
      pageName
      pageData {
        merchantName
        confirmedTransactions {
          ...TransactionListingFields
        }
        billType
        expiresAt
      }
    }
    ... on UnderpaidPage {
      pageName
      pageData {
        billType
      }
    }
    ... on UnderpaymentConfirmedPage {
      pageName
      pageData {
        merchantName
        refundable
        billType
        expiresAt
        fiatTotal
        fiatCurrency
        address
        blockchain
        exchangeRate
        address
        blockchain
        fiatCurrency
        fiatTotal
        exchangeRate
        paymentMethod
        underpaymentConfirmedPaymentId: paymentId
        underpaymentConfirmedRemainingAmount: remainingAmount
        accumulatedAmount
        paymentExpiresAt
        cryptoAmount
        cryptoCurrency
        paymentStartedAt
        confirmedTransactions {
          ...TransactionListingFields
        }
        detectedTransactions {
          ...TransactionListingFields
        }
        underpaymentConfirmedPageMethod: method {
          id
          name
        }
      }
    }
  }

  ${TransactionListingFields}
`;

export { PageFields };
